import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllOrderSourceUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllOrderSource/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrderSourceUser = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllOrderSourceUser;
};


const setActiveOrderSource = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setOrderSourceActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrderSourceUser = data;

    // console.log('Сервер вернул данные по обновлению статуса OrderSource  - ',response);


    return AllOrderSourceUser;
};



const setDeletedOrderSource = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setOrderSourceDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrderSourceUser = data;

    // console.log('Сервер вернул данные по обновлению статуса OrderSource  - ',response);


    return AllOrderSourceUser;
};




const setUpdateOrderSource = async (dataOrderSourceUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setOrderSourceUpdate/'),{
        dataOrderSourceUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrderSourceUser = data;

    // console.log('Сервер вернул данные по обновлению статуса OrderSource  - ',response);


    return AllOrderSourceUser;
};


const setSaveNewOrderSource = async (dataOrderSourceUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewOrderSource/'),{
        dataOrderSourceUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllOrderSourceUser = data;

    // console.log('Сервер вернул данные по обновлению статуса OrderSource  - ',response);


    return AllOrderSourceUser;
};

Mock.onGet('/api/reference/getAllOrderSource').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllOrderSourceUser = await getAllOrderSourceUser();

    // if (!AllOrderSourceUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllOrderSourceUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrderSourceUser,
    ]


})


Mock.onPost('/api/reference/setActiveOrderSource').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOrderSourceUser = await setActiveOrderSource(id,val);

    // if (!AllOrderSourceUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOrderSourceUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrderSourceUser,
    ]


})

Mock.onPost('/api/reference/setDeletedOrderSource').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllOrderSourceUser = await setDeletedOrderSource(id,val);

    // if (!AllOrderSourceUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllOrderSourceUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllOrderSourceUser,
    ]


})


Mock.onPost('/api/reference/setUpdateOrderSource').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOrderSourceUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereOrderSource = await setUpdateOrderSource(dataOrderSourceUpdate);

    // console.log('Серовер вернул данные ',AllOrderSourceUser);

    // if (!refereOrderSource) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereOrderSource) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereOrderSource,
    ]


})


Mock.onPost('/api/reference/setSaveNewOrderSource').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataOrderSourceUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const refereOrderSource = await setSaveNewOrderSource(dataOrderSourceUpdate);

    // console.log('Серовер вернул данные ',AllOrderSourceUser);

    // if (!refereOrderSource) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereOrderSource) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereOrderSource,
    ]
})